import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";

// styles
import { ButtonWrapper, PopUpButton } from "./PopUpButtons.elements";

const PopUpButtons = ({ popuppage }) => {
  const { state, setState } = useContext(AppContext);

  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  // function handleEcg() {
  //   {
  //     state.ecg &&
  //       popuppage.name1 === "ecg" &&
  //       setState((prevState) => ({
  //         ...prevState,
  //         ecg: false,
  //         ecgOffWave1: true,
  //         ecgOffWave2: true,
          
  //       }));
  //   }
  // }

  function handleEcg() {
    state.ecg &&
      popuppage.name1 === "ecg" &&
      setState((prevState) => {
        const updatedNumericValues = [...prevState.numericValues];
        updatedNumericValues[0] = {
          ...updatedNumericValues[0],
          box: {
            ...updatedNumericValues[0].box,
            hr: true,
            spo: false,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
          },
        };

        updatedNumericValues[1] = {
          ...updatedNumericValues[1],
          box: {
            ...updatedNumericValues[1].box,
            hr: false,
            spo: true,
            pvc: false,
            pulse: false,
            rr: false,
            st: false,
            qtc: false,
          },
        };

        updatedNumericValues[3] = {
          ...updatedNumericValues[3],
          box: {
            ...updatedNumericValues[3].box,
            hr: false,
            spo: false,
            pvc: false,
            pulse: true,
            rr: false,
            st: false,
            qtc: false,
          },
        };
  
        return {
          ...prevState,
          ecg: false,
          ecgOffWave1: true,
          ecgOffWave2: true,
          numericValues: updatedNumericValues,
        };
      });
  }

  const buttons = popuppage.buttonText.map((button, index) => {
    return (
      <div key={index}>
        {button === "Confirm" ? (
          <PopUpButton onClick={handleEcg}>{button}</PopUpButton>
        ) : (
          <PopUpButton>{button}</PopUpButton>
        )}
      </div>
    );
  });

  return (
    <>
      <ButtonWrapper onClick={handleBackButtonClick}>{buttons}</ButtonWrapper>
      {}
    </>
  );
};

export default PopUpButtons;
